import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, AfterViewInit, ElementRef, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { prodAPI } from '../../../env';
import { Title } from '@angular/platform-browser';


export interface ResourceItem {
  id: number;
  name: string;
  icon: string;
  rating: string;
  short_description: string;
  url: string;
  tag: string;
  category: string;
  created_at: number;
  updated_at: number;
}

// В компоненте

@Component({
  selector: 'app-top-exchanges',
  templateUrl: './top-exchanges.component.html',
  styleUrls: ['./top-exchanges.component.scss'],
  imports: [MatIconModule, CommonModule]
})
export class TopExchangesComponent implements OnInit, AfterViewInit {
  groupedItems!: Record<string, ResourceItem[]>;
  order!: string[];;
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);
  private titleService = inject(Title);
  private http = inject(HttpClient);

  constructor(private el: ElementRef) { 
    this.registerCustomIcons();
  }

  ngOnInit(): void {
    this.titleService.setTitle('Tools - Kimba.TV');
    this.loadAndGroupItems();
  }

  ngAfterViewInit() {
  this.enableHorizontalScroll();
}

enableHorizontalScroll() {
  setTimeout(() => {
    const carousels = document.querySelectorAll('.carousel');
    
    carousels.forEach(carousel => {
      const element = carousel as HTMLElement;
      
      // Проверяем, нужна ли маска (есть ли скролл)
      if (element.scrollWidth > element.clientWidth) {
        element.classList.add('mask-enabled');
      } else {
        element.classList.remove('mask-enabled');
      }

      const handleWheel = (event: Event) => {
        const wheelEvent = event as WheelEvent;
        if (wheelEvent.deltaY !== 0) {
          wheelEvent.preventDefault();
          element.scrollLeft += wheelEvent.deltaY;
        }
      };
      
      element.addEventListener('wheel', handleWheel as EventListener);
    });
  }, 100);
}


formatCategoryName(category: string): string {
  let formatted = category.replace(/_/g, ' ');
  formatted = formatted.replace(/\b\w/g, (char) => char.toUpperCase());
  
  return formatted;
}

   private loadAndGroupItems(): void {
  this.http.get<ResourceItem[]>(`${prodAPI}/api/public/resourses`)
    .subscribe({
      next: (items) => {
        const result = this.groupByCategory(items);
        this.groupedItems = result.grouped;
        this.order = result.order;
        setTimeout(() => {
          this.enableHorizontalScroll();
        }, 0);
      },
      error: (error) => {
        console.error('Error loading items:', error);
      }
    });
}

private groupByCategory(
  items: ResourceItem[]
): { grouped: Record<string, ResourceItem[]>; order: string[] } {
  const grouped: Record<string, ResourceItem[]> = {};
  const order: string[] = [];
  const bookItems: ResourceItem[] = [];
  let bookCategoryName: string | null = null;

  items.forEach(item => {
    const category = item.category || 'uncategorized';

    if (category.toLowerCase().includes('books')) {
      bookItems.push(item);
      bookCategoryName = bookCategoryName || category;
    } else {
      if (!grouped[category]) {
        grouped[category] = [];
        order.push(category);
      }
      grouped[category].push(item);
    }
  });

  // Добавляем "Books" только если есть элементы
  if (bookItems.length > 0 && bookCategoryName) {
    grouped[bookCategoryName] = bookItems;
    order.push(bookCategoryName);
  }

  return { grouped, order };
}



  getStars(rating: number): number[] {
    const numericRating = typeof rating === 'string' ? parseFloat(rating) : rating;
    const stars: number[] = [];
    const fullStars = Math.floor(numericRating);
    const hasHalf = numericRating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(100);
    }
    if (hasHalf) {
      stars.push(50);
    }
    while (stars.length < 5) {
      stars.push(0);
    }
    return stars;
  }

  private registerCustomIcons() {
    this.iconRegistry.addSvgIcon(
      'twitch',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/twitch.svg')
    );
    this.iconRegistry.addSvgIcon(
      'youtube',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/youtube.svg')
    );
    this.iconRegistry.addSvgIcon(
      'logo',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/logo.svg')
    );
    this.iconRegistry.addSvgIcon(
      'x',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/x.svg')
    );
    this.iconRegistry.addSvgIcon(
      'merch',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/merch.svg')
    );
    this.iconRegistry.addSvgIcon(
      'discord',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/discord.svg')
    );
    this.iconRegistry.addSvgIcon(
      'background',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        '/assets/icons/give-away-background.svg'
      )
    );
    this.iconRegistry.addSvgIcon(
      'star',
      this.sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/star.svg')
    );
  }
}